import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import moment from 'moment';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-reportemployeesummary',
  templateUrl: './reportemployeesummary.component.html',
  styleUrls: ['./reportemployeesummary.component.css']
})
export class ReportemployeesummaryComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  fromdate: any = new Date();
  todate: any = new Date();

  formname: string = "EmployeeSummaryReport";

  
  gridformtype: string = "";
  
  branchid:number=null;
  departmentid:number=null;
  designationid:number=null;
  locationid:number=null;
  branchColl: any = [];
  departmentColl: any = [];
  designationColl: any = [];
  locationColl: any = [];

  checkemp: string ="";
  companycheckColl: any = [];
  filterstatus: string = "ALL";
  empColl: any = [];

 
  
  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Code', field: 'staffcode' },
    { headerName: 'EmployeeName', field: 'empname' },
    { headerName: 'Designation', field: 'designationname' },
    { headerName: 'Department', field: 'departmentname' },
    { headerName: 'Branch', field: 'branchname' },
    { headerName: 'Mobile', field: 'mobile' },
    { headerName: 'Location', field: 'locationname' },
    { headerName: 'Religion', field: 'religionname' },
   
    {
      headerName: 'Join On', field: 'joindt', type:'date'
    },
    { headerName: 'WPS Group Name', field: 'wpsgroupname' },
    { headerName: 'EmailId', field: 'emailid' },
  
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  }; 
  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, public loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private productFindService: NgbModal, private toastr: ToastrService,
    private datePipe: DatePipe) {
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    this.fromdate.setDate(this.fromdate.getDate() - 15);
  }

  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() { 
    this.fngetEmp();
    this.fngetBranch();
    this.fngetDepartment();
    this.fngetDesignation();
    this.fngetLocation();
  }

  
  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }

  onRowDoubleClick() {
 
 
  }

  //Grid
  fnGridReady(params) {
  
  }


  //Event  
  fnActionEditClick() {
    
  }

  fnActionDeleteClick() {
    
  }

  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'Employeelist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
   
  }

  fnActionFilterClick() {

    this.filterbar.filterstatus = this.filterstatus;

    this.isfilter = !this.isfilter;
  }

  fnApplyFilter(data) {
    this.isfilter = !this.isfilter;

    this.filterstatus = data.status;

    this.fngetEmp();

  }

  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetEmp();
    }
    else {
      this.filterstatus = "";
      this.fngetEmp();
    }
  }
  //Get
  fngetEmp() {
    var data = {
      'branchid': this.branchid,
      'departmentid': this.departmentid,
      'designationid': this.designationid,
      'locationid': this.locationid,
      'companyid': this.loginService.fnGetCompanyId(),
      'fromdate': this.fnFormatDatetime(this.fromdate),
      'todate': this.fnFormatDatetime(this.todate),

    }
    this.appService.getReportEmployeeSummary(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {

            
            this.empColl = res.json().result;
            console.log(this.empColl)
            this.fnSetTable();
           

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
 
  //Get
  fngetBranch() {
    var data = {
      'branchid': 0,
     

    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.branchColl = res.json().result;
           

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  
  fngetDesignation() {
    var data = {
      'designationid': 0,
     

    }
    this.appService.getDesignation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.designationColl = res.json().result;
           

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetDepartment() {
    var data = {
      'departmentid': 0,
     

    }
    this.appService.getDepartment(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.departmentColl = res.json().result;
           

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetLocation() {
    var data = {
      'locationid': 0,
     

    }
    this.appService.getLocation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.locationColl = res.json().result;
           

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

 




  fnSetTable() {
    
  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.empColl[index].hoverfocus = "IN"
      }
      else {
        this.empColl[index].hoverfocus = ""
      }
    }
  }

  fnTabHeaderClick(type) {
    this.searchtxt = "";
    this.gridformtype = type;
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }
  
  }  
  
  fnFormatDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        return this.datePipe.transform(dt,"yyyy-MM-dd")  
      }
      
      }else {
      return null
    }
    
  }
  fnCloseForm(){
    try{
      this.router.navigate(['/Reports']);
    }catch(ex){
       this.fnShowErrorMsg(ex);
    }
    }

    fnExport() {

      const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
      modalRef.componentInstance.doctype = this.formname;
      modalRef.componentInstance.columnDefs = this.columnDefs;
      modalRef.componentInstance.contentColl = this.empColl;
      modalRef.componentInstance.fnSetTable();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
    
      
      });
    
    }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}
